"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurrentPaymentTypes = exports.RecurrentPaymentStatus = exports.RecurrentPaymentMethods = void 0;
var RecurrentPaymentMethods;
(function (RecurrentPaymentMethods) {
    RecurrentPaymentMethods["tinkoff"] = "tinkoff";
    RecurrentPaymentMethods["mandarin"] = "mandarin";
})(RecurrentPaymentMethods || (exports.RecurrentPaymentMethods = RecurrentPaymentMethods = {}));
var RecurrentPaymentStatus;
(function (RecurrentPaymentStatus) {
    RecurrentPaymentStatus["init"] = "init";
    RecurrentPaymentStatus["ready"] = "ready";
    RecurrentPaymentStatus["error"] = "error";
    RecurrentPaymentStatus["pause"] = "pause";
    RecurrentPaymentStatus["block"] = "block";
})(RecurrentPaymentStatus || (exports.RecurrentPaymentStatus = RecurrentPaymentStatus = {}));
var RecurrentPaymentTypes;
(function (RecurrentPaymentTypes) {
    RecurrentPaymentTypes["threshold"] = "threshold";
    RecurrentPaymentTypes["frequency"] = "frequency";
})(RecurrentPaymentTypes || (exports.RecurrentPaymentTypes = RecurrentPaymentTypes = {}));
//# sourceMappingURL=recurrent-payments.enum.js.map